const BackBtnSmall = () => {
    return (
        <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.77495 6.55806C9.01903 6.80214 9.01903 7.19786 8.77495 7.44194L4.84189 11.375H16.6663C17.0115 11.375 17.2913 11.6548 17.2913 12C17.2913 12.3452 17.0115 12.625 16.6663 12.625H4.84189L8.77495 16.5581C9.01903 16.8021 9.01903 17.1979 8.77495 17.4419C8.53087 17.686 8.13514 17.686 7.89107 17.4419L2.89107 12.4419C2.64699 12.1979 2.64699 11.8021 2.89107 11.5581L7.89107 6.55806C8.13514 6.31398 8.53087 6.31398 8.77495 6.55806Z" fill="#A1A1A1"/>
        </svg>

    )
}

export default BackBtnSmall